export default __webpack_public_path__ + "static/media/storysize.84d14b1b.png";